<template>
      <div>
            <navbar/>
           <div class="container-fluid">
               
            <h2>Detalle del Contacto</h2>
            <button @click="actualizar">Actualizar</button>
            <router-link style="float: right" :to="{ name: 'notas', params: { id: this.$route.params.id, tipo: 'contactos' }}" class="linkRefnum">Notas</router-link>
            <router-link style="float: right" :to="{ name: 'archivos', params: { id: this.$route.params.id, tipo: 'contactos' }}" class="linkRefnum">Archivos | </router-link>
            <div class="row">
                <div class="col-md-6 ">
                    Identificador: 
                    <input class="form-control" v-model="oneContacto.identificador">
                </div>
                <div class="col-md-6 ">
                    Nombre: 
                    <input class="form-control" v-model="oneContacto.nombre">
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 ">
                     Apellido: 
                    <input class="form-control" v-model="oneContacto.apellido">
                </div>
                <div class="col-md-6 ">
                    Correo: 
                    <input  class="form-control" v-model="oneContacto.email">
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 ">
                    Grupo:
                    <input class="form-control" v-model="oneContacto.gruposkills">
                </div>
                <div class="col-md-6 ">
                    Dirección:
                    <input class="form-control" v-model="oneContacto.direccion">
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 ">
                    Acuerdo:
                    <select class="form-control" v-model="oneContacto.idsla">
                        <option v-for="item in allAcuerdos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                    </select>
                </div>
                <div class="col-md-6 ">
                   Cargo:
                    <input class="form-control" v-model="oneContacto.cargo">
                </div>
            </div>

            <h3>Redes Sociales</h3>
            <div class="row mt-3">
                <div class="col-md-4">
                    Facebook:
                    <input class="form-control" v-model="oneContacto.facebook">
                </div>
                <div class="col-md-4">
                    Twitter:
                    <input class="form-control" v-model="oneContacto.twitter">
                </div>
                <div class="col-md-4">
                    Instagram:
                    <input class="form-control" v-model="oneContacto.instagram">
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-4 ">
                    
                    <h3>Campos Personalizados:</h3>
                    <div v-for="cf  in allCfs" :key="cf.id">
                        <p>{{cf.nombre}}</p>
                        <input class="form-control" v-model="normalizedValue[cf.nombre]">
                    </div>
                    <pre>{{oneContacto.cf}}</pre>
                </div>
                <!-- <div class="col-md-8 ">
                    <h3>Cuentas:</h3>
                    <div>
                        <cuentacontacto tipo="cuenta"></cuentacontacto>
                    </div>
                </div> -->
            </div> 
        </div>        
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import CuentaContacto from './CuentaContacto.vue'
export default {
     components: {
        navbar: () => import('@/views/Agente/navBar.vue'),
        cuentacontacto: () => import('@/views/Agente/CuentaContacto.vue')
    },
    data(){
        return{
            cfs: {}
        }
    },
    computed:{
         ...mapGetters('validatetoken', { 
            oneContacto: 'oneContacto',
            allAcuerdos: 'allAcuerdos',
            allCfs: 'allCfs',
            allCuentas: 'allCuentas'
        }),
        idContacto(){
            return {
                id: this.$route.params.id
            } 
        },
        normalizedValue: {
            get() {
                if (this.oneContacto.cf === undefined || this.oneContacto.cf === null) {
                    return {}
                }
                Object.keys(this.oneContacto.cf).forEach(key => {
                    if (this.oneContacto.cf[key] === '') {
                        this.oneContacto.cf[key] = null
                        // delete this.value[key]
                    }
                })
                return this.oneContacto.cf
            },
            set(data) {
                this.$emit('input', data)
            }
        }
    },
    methods:{
        ...mapActions('validatetoken', {
            getByContacto: 'getByContacto',
            //getAllAcuerdo: 'getAllAcuerdo',
            saveContacto: 'saveContacto',
            getAllCfs: 'getAllCfs',
            getAllCuentas: 'getAllCuentas'
            //proceso
        }),
        getAll(){
            //  {
            //     id: this.$route.params.id,
            //     method: "full"
            // }
            let data = {
                id: this.$route.params.id,
                method: ['acuerdos', 'cfs']
            }

            Promise.all([
                this.getByContacto(data),
                //this.getAllAcuerdo(),
                //this.getAllCfs({ idtipoobjeto: 2 }),
                
            ])
            // .then(()=>{
            //     this.getAllCuentas({
            //         listaids: this.oneContacto.grupocuentas.join()
            //     })
            //     .then((data)=>{
            //         this.$store.commit('validatetoken/setAllCuentaContacto', data)
            //     })
            // })
        },
        actualizar(){
            if (this.oneContacto.email === '') {
                this.oneContacto.email = [this.oneContacto.email]
            }
            this.saveContacto(this.oneContacto)
            .then(()=>{
                this.getAll()
            })
        },
   
    },
    created() {
        this.getAll()
    },
}
</script>

<style>

</style>